import React from "react";
import styled from "styled-components";

const LeftScrollbar = () => {
  return (
    <ScrollContainer>
      <InnerContent>
        {Array.from({ length: 25 }).map((_, i) => (
          <Item key={i}>Item {i + 1}</Item>
        ))}
      </InnerContent>
    </ScrollContainer>
  );
};

const ScrollContainer = styled.div`
  width: 400px;
  height: 300px;
  overflow-y: scroll;
  direction: rtl;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  scroll-behavior: smooth;

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(100, 100, 100, 0.6);
    border-radius: 4px;
    opacity: 0;
    transition: opacity 0.3s;
  }

  &:hover::-webkit-scrollbar-thumb {
    opacity: 1;
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;

  &:hover {
    scrollbar-color: rgba(100, 100, 100, 0.6) transparent;
  }
`;

const InnerContent = styled.div`
  direction: ltr;
  padding: 1rem;
`;

const Item = styled.div`
  margin: 8px 0;
  background-color: #e0e0e0;
  padding: 10px;
  border-radius: 8px;
`;

export default LeftScrollbar;